export default [{
  path: '/duty',
  component: () => import('@/views/duty/main'),
  children: [{
    path: 'crew-member-cfg',
    component: () => import('@/views/duty/crew-member-cfg/main')
  }, {
    path: 'work-time-cfg',
    component: () => import('@/views/duty/work-time-cfg/main')
  }, {
    path: 'work-schedule-dtl-daily',
    component: () => import('@/views/duty/work-schedule-dtl-daily/main')
  }]
}]
